<script>
    import { onDestroy, onMount } from "svelte";
    import { PRConnect } from "@projectroom/ui-lib";
    import axios from "axios";
    import ScenarioSelect from "./ScenarioSelect.svelte";
    import { EmojiPicker } from "../lib/ui";
    import { createEventDispatcher } from "svelte";
    import ImagePicker from "../views/chat-builder/ImagePicker.svelte";
    import { botAssetFolder as folderForBot } from "../views/chat-builder/imageAssetApi";

    export let bot;
    export let button;

    let refButtonContext;
    let refButtonImageFile;
    let refButtonTitle;
    let refButtonSubTitle;

    const BUTTON_TYPE_FIX = "FIX";
    const BUTTON_TYPE_DEFAULT = "DEFAULT";

    let isButtonImagePopup = false;
    let isButtonIconPopup = false;

    // 통합 이미지 라이브러리(ImagePicker) — 봇 빌더에서도 재사용. 봇 문맥 폴더를 시작점(랜딩)으로.
    let libraryOpen = false;
    $: botAssetFolder = folderForBot(bot); // 봇 문맥 폴더(imageAssetApi 공통 규칙 = 이름변경/마이그레이션과 동일)
    const openLibrary = () => {
        libraryOpen = true;
    };
    const onAssetPicked = (e) => {
        const { assetId, url } = e.detail || {};
        if (!assetId || !url) return;
        // 현재 슬롯 유지: buttonImageType 있으면 그대로, 없으면 STACKED(큰카드) 기본.
        const type =
            button.buttonImageType && button.buttonImageType !== "TEXT"
                ? button.buttonImageType
                : "STACKED";
        button.changeImageAsset(assetId, url, type);
        button = button;
        libraryOpen = false;
    };

    let blockDesign = true;
    let navFlag = false;
    let isDisplay = false;

    let iconImageList = {
        insta: false,
        facebook: false,
        kakaotalk: false,
        blog: false,
        youtube: false,
        twitter: false,
        mail: false,
        shop: false,
    };

    let buttonImageInfo = {
        id: "",
        buttonImageContent: "",
        buttonImageType: "",
    };

    onMount(() => {});

    const changeButtonTargetLink = (e) => {
        const targetType = e.target.dataset.type;
        let targetLink = e.target.value;
        // 기업형: 원본 URL 그대로 저장 (렌더 시점에 래퍼 컴포넌트가 videoId 추출 + embed URL 조립)
        // 캐릭터형(레거시): 빌더에서 embed URL로 변환 후 저장 (main_2.7.js는 button.value를 iframe src로 직접 사용)
        if (!bot.isEnterprise && targetType === "IFRAME") {
            if (targetLink.includes("watch")) {
                const urlObject = new URL(targetLink);
                targetLink = `${urlObject.origin}/embed/${urlObject.searchParams.get("v")}`;
            } else if (targetLink.includes("youtu.be")) {
                const urlObject = new URL(targetLink);
                targetLink = `https://www.youtube.com/embed${urlObject.pathname}`;
            }
        }
        button.changeTargetLink(targetLink, targetType);
    };

    const onImageFileSelected = (e) => {
        isButtonIconPopup = false;
        let image = e.target.files[0];
        onFileUpload(image, button.buttonImageType);
    };

    const onFileUpload = (image, layoutType) => {
        const key = `${bot.id}/button-images/${button.id}/${image.name}`;
        const type = image.type;
        PRConnect.send(
            "/api/File/uploadPresignedUrl",
            { key, type },
            (data) => {
                axios
                    .put(data.result, image, {
                        headers: { "Content-Type": type },
                    })
                    .then((response) => {
                        // 카드 타입은 업로드 직후 미리보기 팝업을 띄우지만,
                        // ICON 타입은 인라인 썸네일로 바로 보여주므로 팝업을 생략한다.
                        const onSaved =
                            layoutType === "ICON"
                                ? undefined
                                : () => clickButtonImageModify(button.id);
                        button.changeImage(image.name, layoutType, onSaved);
                    });
            },
        );
    };

    const clickButtonImageModify = (id) => {
        PRConnect.send("/api/Message/getButtonImageContent", { id }, (data) => {
            if (data.header.status === "success") {
                buttonImageInfo = { ...data.result };
                isButtonImagePopup = true;
            }
        });
    };

    const clickButtonImageAssign = () => {
        isButtonImagePopup = false;
    };

    const clickIconImageSubmit = () => {
        const entry = Object.entries(iconImageList).find((e) => e[1] == true);
        if (!entry) return;
        const imageContent = `a-${entry[0]}-icon.png`;
        button.changeImage(imageContent, "ICON");
        isButtonIconPopup = false;
    };

    const clickCustomButtonImage = () => {
        refButtonImageFile.click();
    };

    const clickButtonImageDelete = () => {
        button.deleteImage();
    };
    const clickArrowIcon = () => {
        button.changeDisplayFlag();
        button = button;
    };

    const onEmoji = (e, type) => {
        if (type == "SUB") {
            changeButtonSubTitle(e.detail);
        } else {
            changeButtonTitle(e.detail);
        }
    };

    const changeButtonTitle = (addedContext = "") => {
        const title =
            refButtonTitle.value.slice(0, refButtonTitle.selectionEnd) +
            addedContext +
            refButtonTitle.value.slice(refButtonTitle.selectionEnd);
        button.changeTitle(title);
    };
    const changeButtonSubTitle = (addedContext = "") => {
        const subTitle =
            refButtonSubTitle.value.slice(0, refButtonSubTitle.selectionEnd) +
            addedContext +
            refButtonSubTitle.value.slice(refButtonSubTitle.selectionEnd);
        button.changeSubTitle(subTitle);
    };

    // 간격 조절: 수치 직접입력 대신 프리셋 몇 개로 정리.
    // 데이터 모델은 그대로(title=위 간격, subTitle=아래 간격 px / targetLink=구분선 스타일).
    const DIVIDE_GAPS = [
        { v: 8, label: "좁게", pv: 6 },
        { v: 16, label: "보통", pv: 14 },
        { v: 32, label: "넓게", pv: 26 },
    ];
    const DIVIDE_LINES = [
        { v: "", label: "없음" },
        { v: "SOLID", label: "실선" },
        { v: "DASHED", label: "점선" },
    ];
    const setDivideGap = (v) => {
        // 위/아래 간격을 한 값으로 통일해 바로 저장
        button.title = String(v);
        button.subTitle = String(v);
        button.save();
        button = button;
    };
    // btn을 인자로 받아 템플릿 표현식(isDivideGap(button, g.v))에 button이 등장하게 한다.
    // Svelte가 button을 이 class:active의 의존성으로 추적 → setDivideGap의 button 재할당 시 하이라이트 갱신됨.
    const isDivideGap = (btn, v) =>
        String(btn.title) === String(v) &&
        String(btn.subTitle) === String(v);
    const setDivideLine = (v) => {
        button.changeTargetLink(v, "DIVIDE");
        button = button;
    };

    const clickButtonTypeModify = (e) => {
        let buttonTargetType = e.target.dataset.type;
        if (!buttonTargetType) {
            buttonTargetType = e.target.closest(".elements-con").dataset.type;
        }
        if (!bot.isAuthority("buttonType", buttonTargetType)) {
            return false;
        }
        // 개인정보 입력폼은 최소 1개 항목이 선택되어 있어야 하므로 기본 항목을 시드한다.
        if (buttonTargetType === "PRIVACY") {
            button.changeTargetTypeForPrivacy();
        } else {
            button.changeTargetType(buttonTargetType);
        }
    };

    const clickPrivacyContext = (context) => {
        button.changePrivacyContext(context);
        button = button;
    };

    const changeTargetScenario = (scenarioId, targetType) => {
        button.changeTargetScenario(scenarioId, targetType);
        navFlag = false;
    };

    // 공개 S3 버킷(빌트인 아이콘 / 업로드 이미지 모두 여기서 서빙).
    const S3_PUBLIC_BASE =
        "https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com";

    // 빌트인(기본 제공) 아이콘 이름 패턴: a-{name}-icon.png
    // 이 패턴에 매칭되면 빌트인, 아니면 사용자가 업로드한 이미지로 간주한다.
    // 서버(Bot.js / Message.js)도 동일 규칙으로 URL 베이스를 분기한다.
    const BUILTIN_ICON_PATTERN = /^a-.+-icon\.png$/;
    const isBuiltinIcon = (content) =>
        !!content && BUILTIN_ICON_PATTERN.test(content);

    // 레이아웃 타입: 기업형은 전체, 캐릭터형은 텍스트/아이콘/큰카드만 노출한다.
    const getLayoutTypes = (isEnterprise) => {
        const all = [
            { type: null, label: "텍스트" },
            { type: "ICON", label: "아이콘" },
            { type: "INLINE-SM", label: "작은카드" },
            { type: "INLINE-LG", label: "중간카드" },
            { type: "STACKED", label: "큰카드" },
        ];
        if (isEnterprise) return all;
        const characterTypes = new Set([null, "ICON", "STACKED"]);
        return all.filter((item) => characterTypes.has(item.type));
    };
    $: layoutTypes = getLayoutTypes(bot.isEnterprise);

    // 저장된 buttonImageContent(예: a-insta-icon.png)에서 선택된 빌트인 아이콘 이름을 파생한다.
    // 초기 로드/리로드 시에도 선택 상태가 복원되도록 반응형으로 처리.
    const parseInlineIcon = (content) => {
        if (!isBuiltinIcon(content)) return null;
        const match = content.match(/^a-(.+)-icon\.png$/);
        return match ? match[1] : null;
    };

    $: selectedInlineIcon =
        button.buttonImageType === "ICON"
            ? parseInlineIcon(button.buttonImageContent)
            : null;

    // ICON 타입이면서 빌트인 패턴이 아니면 사용자가 업로드한 아이콘이다.
    // 미리보기 썸네일은 공개 S3의 button-images 경로에서 직접 서빙한다.
    $: uploadedIconUrl =
        button.buttonImageType === "ICON" &&
        button.buttonImageContent &&
        !isBuiltinIcon(button.buttonImageContent)
            ? /^https?:\/\//.test(button.buttonImageContent)
                ? button.buttonImageContent // 자산(assetId) URL은 그대로 미리보기(듀얼모드)
                : `${S3_PUBLIC_BASE}/${bot.id}/button-images/${button.id}/${button.buttonImageContent}`
            : null;

    const selectLayoutType = (type) => {
        if (!type) {
            // '텍스트'는 이미지 표시만 끄고 이미지명(buttonImageContent)은 보존한다.
            // (deleteImage로 내용까지 지우면 다른 레이아웃으로 되돌릴 때 이미지가 사라짐)
            // 두 렌더러 모두 buttonImageType 유무로 이미지를 게이팅하므로 type=null이면 텍스트만 표시됨.
            if (button.buttonImageType !== null) {
                button.changeImageType(null);
            }
            button = button;
            return;
        }
        button.changeImageType(type);
        button = button;
    };

    const selectInlineIcon = (e) => {
        const type = e.target.dataset.type;
        if (!type) return;
        button.changeImage(`a-${type}-icon.png`, "ICON");
        button = button;
    };

    const clickButtonImageUpload = () => {
        clickButtonImageModify(button.id);
    };

    const clickIconImage = (iconExist) => {
        isButtonIconPopup = true;
        for (let i in iconImageList) {
            iconImageList[i] = false;
        }
        if (iconExist) {
            const iconName = button.buttonImageContent;
            const regex = /a-(.*?)-icon\.png/;
            const iconType = iconName.match(regex)[1];
            iconImageList[iconType] = true;
        }
        iconImageList = { ...iconImageList };
    };

    const clickIconImageSelected = (e) => {
        const type = e.target.dataset.type;
        for (let i in iconImageList) {
            iconImageList[i] = false;
        }
        iconImageList[type] = true;
        iconImageList = { ...iconImageList };
    };

    const clickButtonDelete = () => {
        bot.defaultChar.deleteFixedButton(button);
    };

    const clickActiveButton = (e) => {
        if (["INPUT", "TEXTAREA", "SELECT"].includes(e.target.tagName)) return;
        bot.defaultChar.setActiveButton(button);
    };
</script>

<div class="content-con-wrapper" on:click={clickActiveButton}>
    {#if button.isTargetTypeIframe()}
        <img
            width="15"
            loading="lazy"
            src="/static/images/move-icon.svg"
            alt=""
            class="image-145"
        />
        <div class="youtube-block-wrap">
            <div class="link-block" class:active={button.active}>
                <div class="link-block-title">
                    <div class="title">
                        <img
                            loading="lazy"
                            src="/static/images/youtube-btn-icon.svg"
                            alt=""
                            class="image-146"
                        />
                        <div class="text-block-93">
                            {"유튜브"}
                        </div>
                    </div>
                    <div class="button-action-wrapper">
                        <img
                            loading="lazy"
                            src="/static/images/trashcan-icon.svg"
                            on:click={clickButtonDelete}
                        />
                        <img
                            loading="lazy"
                            src="/static/images/arrow-icon.svg"
                            class:rotate={button.hideFlag}
                            on:click={clickArrowIcon}
                        />
                    </div>
                </div>
                <div class="link-block-form" class:hide={button.hideFlag}>
                    <div class="text-block-94">
                        {"연결시킬 링크 주소"}
                    </div>
                    <div class="div-block-76">
                        <div
                            class="youtube-input-form w-form"
                            class:block-design={blockDesign}
                        >
                            <div
                                id="email-form"
                                name="email-form"
                                data-name="Email Form"
                                method="get"
                                class="link-form"
                            >
                                <input
                                    type="text"
                                    class="name-text-form w-input"
                                    data-type="IFRAME"
                                    autofocus="false"
                                    maxlength="256"
                                    name="name-4"
                                    data-name="Name 4"
                                    placeholder={"연결시킬 유튜브 링크 주소를 붙여주세요!"}
                                    id="name-4"
                                    value={button.targetLink}
                                    on:blur={(e) => changeButtonTargetLink(e)}
                                    on:change={(e) => changeButtonTargetLink(e)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {:else if button.isTargetTypeLink()}
        <img
            width="15"
            loading="lazy"
            src="/static/images/move-icon.svg"
            alt=""
            class="image-145"
        />
        <div class="link-block-wrap">
            <div class="link-block" class:active={button.active}>
                <div class="link-block-title">
                    <div class="title">
                        <img
                            loading="lazy"
                            src="/static/images/link-btn-icon.svg"
                            alt=""
                            class="image-146"
                        />
                        <div class="text-block-93">
                            {"링크"}
                        </div>
                    </div>
                    <div class="button-action-wrapper">
                        <img
                            loading="lazy"
                            src="/static/images/trashcan-icon.svg"
                            on:click={clickButtonDelete}
                        />
                        <img
                            loading="lazy"
                            src="/static/images/arrow-icon.svg"
                            class:rotate={button.hideFlag}
                            on:click={clickArrowIcon}
                        />
                    </div>
                </div>
                <div class="linktext-block-form" class:hide={button.hideFlag}>
                    <div class="text-block-94">
                        {"링크 버튼 텍스트"}
                    </div>
                    <div class="linktext-input-form-copy w-form">
                        <div id="button-title" method="get" class="link-form">
                            <input
                                type="text"
                                class="name-text-form w-input"
                                maxlength="256"
                                name="name-4"
                                bind:this={refButtonTitle}
                                placeholder={"ex) 아바톡 인스타 바로가기"}
                                id="name-4"
                                value={button.title}
                                on:blur={() => changeButtonTitle()}
                                on:change={() => changeButtonTitle()}
                            />
                            <EmojiPicker on:emoji={onEmoji} />
                        </div>
                    </div>
                </div>
                <div class="link-block-form" class:hide={button.hideFlag}>
                    <div class="text-block-94">
                        {"연결시킬 링크 주소"}
                    </div>
                    <div class="div-block-76">
                        <div class="link-input-form w-form">
                            <div
                                id="email-form"
                                name="email-form"
                                data-name="Email Form"
                                method="get"
                                class="link-form"
                            >
                                <input
                                    type="text"
                                    class="name-text-form w-input"
                                    data-type="LINK"
                                    autofocus="false"
                                    maxlength="256"
                                    name="field"
                                    data-name="링크"
                                    placeholder={"연결시킬 링크 주소를 붙여주세요!"}
                                    id="field-3"
                                    value={button.targetLink}
                                    on:blur={(e) => changeButtonTargetLink(e)}
                                    on:change={(e) => changeButtonTargetLink(e)}
                                />
                            </div>
                        </div>
                        <input
                            accept="image/png, image/jpeg, image/jpg"
                            bind:this={refButtonImageFile}
                            type="file"
                            name="add"
                            on:change={onImageFileSelected}
                            hidden
                            tabindex="-1"
                        />
                    </div>
                </div>
                <div class="link-block-form" class:hide={button.hideFlag}>
                    <div class="text-block-94">레이아웃</div>
                    <div class="layout-type-wrapper">
                        {#each layoutTypes as item}
                            <div
                                class="layout-type-item pointer"
                                class:selected={item.type === null
                                    ? !button.buttonImageType ||
                                      button.buttonImageType === "TEXT"
                                    : button.buttonImageType === item.type}
                                on:click={() => selectLayoutType(item.type)}
                            >
                                {#if item.type === null}
                                    <svg viewBox="0 0 40 30" class="layout-icon"
                                        ><rect
                                            x="6"
                                            y="9"
                                            width="28"
                                            height="4"
                                            rx="2"
                                            fill="currentColor"
                                            opacity=".5"
                                        /><rect
                                            x="6"
                                            y="17"
                                            width="20"
                                            height="4"
                                            rx="2"
                                            fill="currentColor"
                                            opacity=".5"
                                        /></svg
                                    >
                                {:else if item.type === "ICON"}
                                    <svg viewBox="0 0 40 30" class="layout-icon"
                                        ><rect
                                            x="5"
                                            y="7"
                                            width="10"
                                            height="10"
                                            rx="2"
                                            fill="currentColor"
                                            opacity=".6"
                                        /><rect
                                            x="19"
                                            y="9"
                                            width="16"
                                            height="3"
                                            rx="1.5"
                                            fill="currentColor"
                                            opacity=".5"
                                        /><rect
                                            x="19"
                                            y="15"
                                            width="11"
                                            height="3"
                                            rx="1.5"
                                            fill="currentColor"
                                            opacity=".5"
                                        /></svg
                                    >
                                {:else if item.type === "INLINE-SM"}
                                    <svg viewBox="0 0 40 30" class="layout-icon"
                                        ><rect
                                            x="5"
                                            y="5"
                                            width="13"
                                            height="13"
                                            rx="2"
                                            fill="currentColor"
                                            opacity=".6"
                                        /><rect
                                            x="21"
                                            y="9"
                                            width="14"
                                            height="3"
                                            rx="1.5"
                                            fill="currentColor"
                                            opacity=".5"
                                        /><rect
                                            x="21"
                                            y="15"
                                            width="10"
                                            height="3"
                                            rx="1.5"
                                            fill="currentColor"
                                            opacity=".5"
                                        /></svg
                                    >
                                {:else if item.type === "INLINE-LG"}
                                    <svg viewBox="0 0 40 30" class="layout-icon"
                                        ><rect
                                            x="5"
                                            y="3"
                                            width="15"
                                            height="22"
                                            rx="2"
                                            fill="currentColor"
                                            opacity=".6"
                                        /><rect
                                            x="23"
                                            y="10"
                                            width="12"
                                            height="3"
                                            rx="1.5"
                                            fill="currentColor"
                                            opacity=".5"
                                        /><rect
                                            x="23"
                                            y="16"
                                            width="8"
                                            height="3"
                                            rx="1.5"
                                            fill="currentColor"
                                            opacity=".5"
                                        /></svg
                                    >
                                {:else if item.type === "STACKED"}
                                    <svg viewBox="0 0 40 30" class="layout-icon"
                                        ><rect
                                            x="5"
                                            y="3"
                                            width="30"
                                            height="16"
                                            rx="2"
                                            fill="currentColor"
                                            opacity=".6"
                                        /><rect
                                            x="11"
                                            y="22"
                                            width="18"
                                            height="3"
                                            rx="1.5"
                                            fill="currentColor"
                                            opacity=".5"
                                        /></svg
                                    >
                                {/if}
                                <span class="layout-type-label"
                                    >{item.label}</span
                                >
                            </div>
                        {/each}
                    </div>
                    {#if button.buttonImageType === "ICON"}
                        <div class="inline-icon-area">
                            <div
                                class="inline-icon-grid"
                                on:click={selectInlineIcon}
                            >
                                {#if uploadedIconUrl}
                                    <!-- 사용자가 업로드한 아이콘(빌트인 패턴 아님)은 선택 상태로 표시 -->
                                    <img
                                        src={uploadedIconUrl}
                                        alt=""
                                        class="inline-icon uploaded selected"
                                    />
                                {/if}
                                <img
                                    data-type="insta"
                                    src="/static/images/insta-icon.png"
                                    alt=""
                                    class="inline-icon"
                                    class:selected={selectedInlineIcon ===
                                        "insta"}
                                />
                                <img
                                    data-type="facebook"
                                    src="/static/images/facebook-icon.png"
                                    alt=""
                                    class="inline-icon"
                                    class:selected={selectedInlineIcon ===
                                        "facebook"}
                                />
                                <img
                                    data-type="kakaotalk"
                                    src="/static/images/kakaotalk-icon.png"
                                    alt=""
                                    class="inline-icon"
                                    class:selected={selectedInlineIcon ===
                                        "kakaotalk"}
                                />
                                <img
                                    data-type="blog"
                                    src="/static/images/blog-icon.png"
                                    alt=""
                                    class="inline-icon"
                                    class:selected={selectedInlineIcon ===
                                        "blog"}
                                />
                                <img
                                    data-type="youtube"
                                    src="/static/images/youtube-icon.png"
                                    alt=""
                                    class="inline-icon"
                                    class:selected={selectedInlineIcon ===
                                        "youtube"}
                                />
                                <img
                                    data-type="twitter"
                                    src="/static/images/twitter-icon.png"
                                    alt=""
                                    class="inline-icon"
                                    class:selected={selectedInlineIcon ===
                                        "twitter"}
                                />
                                <img
                                    data-type="mail"
                                    src="/static/images/mail-icon.png"
                                    alt=""
                                    class="inline-icon"
                                    class:selected={selectedInlineIcon ===
                                        "mail"}
                                />
                                <img
                                    data-type="shop"
                                    src="/static/images/shop-icon.png"
                                    alt=""
                                    class="inline-icon"
                                    class:selected={selectedInlineIcon ===
                                        "shop"}
                                />
                            </div>
                            <div class="image-upload-area">
                                <div
                                    class="file-upload-btn image-upload-btn-before"
                                    on:click={clickCustomButtonImage}
                                >
                                    {"이미지 업로드"}
                                </div>
                                <div
                                    class="file-upload-btn image-upload-btn-before"
                                    on:click={openLibrary}
                                >
                                    {"라이브러리에서 선택"}
                                </div>
                            </div>
                        </div>
                    {/if}
                    {#if button.buttonImageType && button.buttonImageType !== "TEXT" && button.buttonImageType !== "ICON"}
                        <!-- 아이콘 프리셋(a-*-icon.png)은 카드 타입의 '업로드된 이미지'가 아니므로 무시한다. -->
                        {@const hasUploadedImage =
                            button.buttonImageContent &&
                            !parseInlineIcon(button.buttonImageContent)}
                        <div class="image-upload-area">
                            {#if hasUploadedImage}
                                <div
                                    class="file-upload-btn image-upload-btn edit pointer"
                                    on:click={clickButtonImageDelete}
                                >
                                    <div
                                        class="file-upload-text"
                                        on:click|stopPropagation={clickButtonImageUpload}
                                    >
                                        {"버튼 이미지 보기"}
                                    </div>
                                </div>
                            {:else}
                                <div
                                    class="file-upload-btn image-upload-btn-before"
                                    on:click={clickCustomButtonImage}
                                >
                                    {"이미지 업로드"}
                                </div>
                                <div
                                    class="file-upload-btn image-upload-btn-before"
                                    on:click={openLibrary}
                                >
                                    {"라이브러리에서 선택"}
                                </div>
                            {/if}
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    {:else if button.isTargetTypeScenario()}
        <img
            width="15"
            loading="lazy"
            src="/static/images/move-icon.svg"
            alt=""
            class="image-145"
        />
        <div class="youtube-block-wrap">
            <div class="link-block" class:active={button.active}>
                <div class="link-block-title">
                    <div class="title">
                        <img
                            loading="lazy"
                            src="/static/images/talk-icon.svg"
                            alt=""
                            class="image-146"
                        />
                        <div class="text-block-93">
                            {"섹션 연결하기"}
                        </div>
                    </div>
                    <div class="button-action-wrapper">
                        <img
                            loading="lazy"
                            src="/static/images/trashcan-icon.svg"
                            on:click={clickButtonDelete}
                        />
                        <img
                            loading="lazy"
                            src="/static/images/arrow-icon.svg"
                            class:rotate={button.hideFlag}
                            on:click={clickArrowIcon}
                        />
                    </div>
                </div>
                <div class="link-block-form" class:hide={button.hideFlag}>
                    <div class="text-block-94">
                        {"섹션 연결 버튼 텍스트"}
                    </div>
                    <div class="div-block-76">
                        <div class="youtube-input-form w-form">
                            <div class="link-form">
                                <input
                                    type="text"
                                    class="name-text-form w-input"
                                    data-type="IFRAME"
                                    autofocus="false"
                                    maxlength="256"
                                    name="name-4"
                                    bind:this={refButtonTitle}
                                    placeholder={"섹션 버튼에 적힐 내용을 적어주세요!"}
                                    id="name-4"
                                    value={button.title}
                                    on:blur={() => changeButtonTitle()}
                                    on:change={() => changeButtonTitle()}
                                />
                                <EmojiPicker on:emoji={onEmoji} />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="link-block-form" class:hide={button.hideFlag}>
                    <div class="text-block-94">
                        {"연결시킬 섹션"}
                    </div>
                    <div class="div-block-76">
                        <div class="youtube-input-form w-form">
                            <div class="scenario-dropdown">
                                <ScenarioSelect {bot} {button} {blockDesign} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {:else if button.isTargetTypePrivacy()}
        <img
            width="15"
            loading="lazy"
            src="/static/images/move-icon.svg"
            alt=""
            class="image-145"
        />
        <div class="form-block-wrap">
            <div class="link-block" class:active={button.active}>
                <div class="link-block-title">
                    <div class="title">
                        <img
                            loading="lazy"
                            src="/static/images/form-btn-icon.svg"
                            alt=""
                            class="image-146"
                        />
                        <div class="text-block-93">
                            {"개인정보 입력폼"}
                        </div>
                    </div>
                    <div class="button-action-wrapper">
                        <img
                            loading="lazy"
                            src="/static/images/trashcan-icon.svg"
                            on:click={clickButtonDelete}
                        />
                        <img
                            loading="lazy"
                            src="/static/images/arrow-icon.svg"
                            class:rotate={button.hideFlag}
                            on:click={clickArrowIcon}
                        />
                    </div>
                </div>
                <div class="linktext-block-form" class:hide={button.hideFlag}>
                    <div class="text-block-94">
                        {"입력폼 타이틀 문구"}
                    </div>
                    <div class="linktext-input-form-copy w-form">
                        <div class="link-form">
                            <input
                                type="text"
                                class="name-text-form w-input"
                                bind:this={refButtonTitle}
                                autofocus="false"
                                value={button.title}
                                maxlength="256"
                                name="name-4"
                                data-name="Name 4"
                                placeholder={"ex) 이벤트 신청 폼"}
                                on:blur={() => changeButtonTitle()}
                                on:change={() => changeButtonTitle()}
                            />
                            <EmojiPicker on:emoji={onEmoji} />
                        </div>
                    </div>
                </div>
                <div class="linktext-block-form" class:hide={button.hideFlag}>
                    <div class="text-block-94">
                        {"입력폼 서브 문구"}
                    </div>
                    <div class="linktext-input-form-copy w-form">
                        <div class="link-form">
                            <input
                                type="text"
                                class="name-text-form w-input"
                                bind:this={refButtonSubTitle}
                                autofocus="false"
                                value={button.subTitle || ""}
                                maxlength="256"
                                name="name-4"
                                data-name="Name 4"
                                placeholder={"나의 최신 소식을 듣고 싶다면 정보를 입력해줘~"}
                                on:blur={() => changeButtonSubTitle()}
                                on:change={() => changeButtonSubTitle()}
                            />
                            <EmojiPicker
                                on:emoji={(e) => onEmoji(e, "SUB")}
                            />
                        </div>
                    </div>
                </div>
                <div
                    class="customerinfo-block-form"
                    class:hide={button.hideFlag}
                >
                    <div class="text-block-94">
                        {"받아 볼 고객 정보"}
                    </div>
                    <div class="checkbox-wrap">
                        <div class="checkbox-grid _3">
                            <label class="p-radio-btn">
                                <div
                                    class="radio-btn"
                                    class:w--redirected-checked={button.isPrivacyContext(
                                        "NAME",
                                    )}
                                    on:click={() => clickPrivacyContext("NAME")}
                                ></div>
                                <input
                                    type="checkbox"
                                    id="checkbox-7"
                                    name="checkbox-7"
                                    data-name="Checkbox 7"
                                    style="opacity:0;position:absolute;z-index:-1"
                                    checked={button.isPrivacyContext("NAME")}
                                />
                                <span
                                    class="checkbox-label-2 w-form-label"
                                    for="checkbox-7"
                                    on:click={() => clickPrivacyContext("NAME")}
                                    >{"성함"}</span
                                >
                            </label>
                            <label class="p-radio-btn">
                                <div
                                    class="radio-btn"
                                    class:w--redirected-checked={button.isPrivacyContext(
                                        "EMAIL",
                                    )}
                                    on:click={() => clickPrivacyContext("EMAIL")}
                                ></div>
                                <input
                                    type="checkbox"
                                    id="checkbox-7"
                                    name="checkbox-7"
                                    data-name="Checkbox 7"
                                    style="opacity:0;position:absolute;z-index:-1"
                                    checked={button.isPrivacyContext("EMAIL")}
                                />
                                <span
                                    class="checkbox-label-2 w-form-label"
                                    for="checkbox-7"
                                    on:click={() => clickPrivacyContext("EMAIL")}
                                    >{"이메일"}</span
                                >
                            </label>
                            <label class="p-radio-btn">
                                <div
                                    class="radio-btn"
                                    class:w--redirected-checked={button.isPrivacyContext(
                                        "PHONE",
                                    )}
                                    on:click={() => clickPrivacyContext("PHONE")}
                                ></div>
                                <input
                                    type="checkbox"
                                    id="checkbox-7"
                                    name="checkbox-7"
                                    data-name="Checkbox 7"
                                    style="opacity:0;position:absolute;z-index:-1"
                                    checked={button.isPrivacyContext("PHONE")}
                                />
                                <span
                                    class="checkbox-label-2 w-form-label"
                                    for="checkbox-7"
                                    on:click={() => clickPrivacyContext("PHONE")}
                                    >{"전화번호"}</span
                                >
                            </label>
                        </div>
                    </div>
                </div>
                {#if !bot.isEnterprise}
                <div class="link-block-form" class:hide={button.hideFlag}>
                    <div class="text-block-94">
                        {"연결시킬 섹션"}
                    </div>
                    <div class="div-block-76">
                        <div class="youtube-input-form w-form">
                            <div class="scenario-dropdown">
                                <div class="select-wrapper">
                                    <div
                                        class="dropdown-toggle-scenario w-dropdown-toggle"
                                        id="w-dropdown-toggle-2"
                                        aria-controls="w-dropdown-list-2"
                                        aria-haspopup="menu"
                                        aria-expanded="false"
                                        role="button"
                                        tabindex="0"
                                        on:click={() => (navFlag = !navFlag)}
                                    >
                                        {#if button.isScenarioSelected()}
                                            <img
                                                class="selected-image"
                                                src="/static/images/scenario-connect-icon-s.svg"
                                                loading="lazy"
                                                class:block-design={blockDesign}
                                            />
                                            <div
                                                class="icon-2 w-icon-dropdown-toggle"
                                                aria-hidden="true"
                                            ></div>
                                            <div class="text-block-26">
                                                {button.getTargetScenarioTitle(
                                                    button.targetScenarioId,
                                                )}
                                            </div>
                                        {:else}
                                            <div
                                                class="icon-2 w-icon-dropdown-toggle"
                                                aria-hidden="true"
                                            ></div>
                                            <div class="text-block-26">
                                                {"입력 완료 시 다음으로 넘어갈 섹션을 선택해주세요!"}
                                            </div>
                                        {/if}
                                    </div>
                                    <nav
                                        class="dropdown-list-3 w-dropdown-list"
                                        class:w--open={navFlag}
                                        id="w-dropdown-list-2"
                                        aria-labelledby="w-dropdown-toggle-2"
                                        on:mouseleave={() => (navFlag = false)}
                                    >
                                        <div class="dropdown-con-wrap">
                                            <div class="dropdown-title">
                                                <div class="text-block-25">
                                                    {"섹션 연결"}
                                                </div>
                                            </div>
                                            {#each button.getScenarioList() as scenario}
                                                <div
                                                    class="scenario-con"
                                                    on:click={() =>
                                                        changeTargetScenario(
                                                            scenario.id,
                                                            "PRIVACY",
                                                        )}
                                                >
                                                    <img
                                                        src="/static/images/scenario-connect-icon.svg"
                                                        loading="lazy"
                                                        alt=""
                                                        class="image-150"
                                                    />
                                                    <div class="text-block-101">
                                                        {scenario.title}
                                                    </div>
                                                </div>
                                            {/each}
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/if}
            </div>
        </div>
    {:else if button.isTargetTypeText()}
        <img
            width="15"
            loading="lazy"
            src="/static/images/move-icon.svg"
            alt=""
            class="image-145"
        />
        <div class="text-block-wrap">
            <div class="link-block" class:active={button.active}>
                <div class="link-block-title">
                    <div class="title">
                        <img
                            loading="lazy"
                            src="/static/images/text-btn-icon.svg"
                            alt=""
                            class="image-146"
                        />
                        <div class="text-block-93">
                            {"텍스트"}
                        </div>
                    </div>
                    <div class="button-action-wrapper">
                        <img
                            loading="lazy"
                            src="/static/images/trashcan-icon.svg"
                            on:click={clickButtonDelete}
                        />
                        <img
                            loading="lazy"
                            src="/static/images/arrow-icon.svg"
                            class:rotate={button.hideFlag}
                            on:click={clickArrowIcon}
                        />
                    </div>
                </div>
                <div class="linktext-block-form">
                    <div class="text-block-94">
                        {"타이틀 텍스트"}
                    </div>
                    <div class="linktext-input-form-copy w-form">
                        <div
                            name="email-form"
                            data-name="Email Form"
                            method="get"
                            class="link-form"
                            aria-label="Email Form"
                        >
                            <input
                                type="text"
                                class="name-text-form w-input"
                                autofocus="false"
                                maxlength="256"
                                name="name-4"
                                bind:this={refButtonTitle}
                                placeholder={"제목을 작성해주세요"}
                                id="name-4"
                                value={button.title}
                                on:blur={() => changeButtonTitle()}
                                on:change={() => changeButtonTitle()}
                            />
                            <EmojiPicker on:emoji={onEmoji} />
                        </div>
                    </div>
                </div>
                <div class="linktext-block-form">
                    <div class="text-block-94">
                        {"서브 텍스트"}
                    </div>
                    <div class="linktext-input-form-copy w-form">
                        <div
                            name="email-form"
                            data-name="Email Form"
                            method="get"
                            class="link-form"
                        >
                            <input
                                type="text"
                                class="name-text-form w-input"
                                autofocus="false"
                                maxlength="256"
                                name="name-4"
                                bind:this={refButtonSubTitle}
                                placeholder={"내용을 작성해주세요"}
                                id="name-4"
                                value={button.subTitle}
                                on:blur={() => changeButtonSubTitle()}
                                on:change={() => changeButtonSubTitle()}
                            />
                            <EmojiPicker on:emoji={onEmoji} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {:else if button.isTargetTypeDivide()}
        <img
            width="15"
            loading="lazy"
            src="/static/images/move-icon.svg"
            alt=""
            class="image-145"
        />
        <div class="gap-block-wrap">
            <div class="link-block" class:active={button.active}>
                <div class="link-block-title">
                    <div class="title">
                        <img
                            loading="lazy"
                            src="/static/images/gap-btn-icon.svg"
                            alt=""
                            class="image-146"
                        />
                        <div class="text-block-93">
                            {"간격 조절"}
                        </div>
                    </div>
                    <div class="button-action-wrapper">
                        <img
                            loading="lazy"
                            src="/static/images/trashcan-icon.svg"
                            on:click={clickButtonDelete}
                        />
                        <img
                            loading="lazy"
                            src="/static/images/arrow-icon.svg"
                            class:rotate={button.hideFlag}
                            on:click={clickArrowIcon}
                        />
                    </div>
                </div>
                <div class="gap-block">
                    <div class="text-block-94">간격</div>
                    <div class="divide-grid">
                        {#each DIVIDE_GAPS as g (g.v)}
                            <button
                                type="button"
                                class="divide-card"
                                class:active={isDivideGap(button, g.v)}
                                on:click={() => setDivideGap(g.v)}
                            >                                <div class="divide-gap-preview">
                                    <span class="dv-bar"></span>
                                    <span class="dv-gap" style="height:{g.pv}px"></span>
                                    <span class="dv-bar"></span>
                                </div>
                                <span class="divide-card-label">{g.label}</span>
                            </button>
                        {/each}
                    </div>
                    <div class="text-block-94 divide-second-label">구분선</div>
                    <div class="divide-grid">
                        {#each DIVIDE_LINES as ln (ln.v)}
                            <button
                                type="button"
                                class="divide-card"
                                class:active={ln.v === ""
                                    ? !button.targetLink
                                    : button.isTargetLink(ln.v)}
                                on:click={() => setDivideLine(ln.v)}
                            >                                <div class="divide-line-preview">
                                    {#if ln.v === "SOLID"}
                                        <span class="dv-line solid"></span>
                                    {:else if ln.v === "DASHED"}
                                        <span class="dv-line dashed"></span>
                                    {:else}
                                        <span class="dv-line-none">없음</span>
                                    {/if}
                                </div>
                                <span class="divide-card-label">{ln.label}</span>
                            </button>
                        {/each}
                    </div>
                </div>
            </div>
        </div>
    {:else}
        <img
            width="15"
            loading="lazy"
            src="/static/images/move-icon.svg"
            alt=""
            class="image-145"
        />
        <div class="content-elements-wrapper">
            <div class="elements-con-wrap">
                <a
                    href="#"
                    class="elements-con w-inline-block"
                    data-type="LINK"
                    on:click|preventDefault={clickButtonTypeModify}
                >
                    <img
                        loading="lazy"
                        src="/static/images/link-btn-icon.svg"
                        alt=""
                    />
                    <div class="content-text">
                        {"링크"}
                    </div>
                </a>
                <a
                    href="#"
                    class="elements-con w-inline-block"
                    data-type="SCENARIO"
                    on:click|preventDefault={clickButtonTypeModify}
                >
                    <img
                        loading="lazy"
                        src="/static/images/talk-icon.svg"
                        alt=""
                    />
                    <div class="content-text">
                        {"섹션 연결하기"}
                    </div>
                    {#if !bot.isAvailableType("buttonType", "SCENARIO")}
                        <img class="lock-image" src="/static/images/lock.svg" />
                    {/if}
                </a>
            </div>
            <div class="elements-con-wrap">
                <a
                    href="#"
                    class="elements-con w-inline-block"
                    data-type="IFRAME"
                    on:click|preventDefault={clickButtonTypeModify}
                >
                    <img
                        loading="lazy"
                        src="/static/images/youtube-btn-icon.svg"
                        alt=""
                    />
                    <div class="content-text">
                        {"유튜브"}
                    </div>
                    {#if !bot.isAvailableType("buttonType", "IFRAME")}
                        <img class="lock-image" src="/static/images/lock.svg" />
                    {/if}
                </a>
                <a
                    href="#"
                    class="elements-con w-inline-block"
                    data-type="TEXT"
                    on:click|preventDefault={clickButtonTypeModify}
                >
                    <img
                        loading="lazy"
                        src="/static/images/text-btn-icon.svg"
                        alt=""
                    />
                    <div class="content-text">
                        {"텍스트"}
                    </div>
                    {#if !bot.isAvailableType("buttonType", "TEXT")}
                        <img class="lock-image" src="/static/images/lock.svg" />
                    {/if}
                </a>
            </div>
            <div class="elements-con-wrap">
                <a
                    href="#"
                    class="elements-con w-inline-block"
                    data-type="PRIVACY"
                    on:click|preventDefault={clickButtonTypeModify}
                >
                    <img
                        loading="lazy"
                        src="/static/images/form-btn-icon.svg"
                        alt=""
                    />
                    <div class="content-text">
                        {"개인정보 입력폼"}
                    </div>
                    {#if !bot.isAvailableType("buttonType", "PRIVACY")}
                        <img class="lock-image" src="/static/images/lock.svg" />
                    {/if}
                </a>
                <a
                    href="#"
                    class="elements-con w-inline-block"
                    data-type="DIVIDE"
                    on:click|preventDefault={clickButtonTypeModify}
                >
                    <img
                        loading="lazy"
                        src="/static/images/link-btn-icon.svg"
                        alt=""
                    />
                    <div class="content-text">
                        {"간격조절"}
                    </div>
                    {#if !bot.isAvailableType("buttonType", "DIVIDE")}
                        <img class="lock-image" src="/static/images/lock.svg" />
                    {/if}
                </a>
            </div>
            <div class="elements-con-wrap">
                <a href="#" class="elements-con none w-inline-block">
                    <img
                        loading="lazy"
                        src="/static/images/Commerce-btn-icon.svg"
                        alt=""
                        class="image-147"
                    />
                    <div class="content-text none">
                        {"굿즈 판매"}
                    </div>
                </a>
            </div>
        </div>
    {/if}
</div>
<ImagePicker
    bind:open={libraryOpen}
    mode="single"
    contextFolder={botAssetFolder}
    currentAssetId={button.buttonImageAssetId}
    on:select={onAssetPicked}
/>

<div
    class="button-image-popup"
    class:show={isButtonImagePopup}
    on:click={() => (isButtonImagePopup = false)}
>
    <div class="popup-layer button-image-layer" on:click|stopPropagation>
        <div class="popup-wrapper">
            <div class="image-layer" id="imageContainment">
                <!-- <img class="image-3" id="buttonImagePopup" src={buttonImageInfo.buttonImageContent}/> -->
                <img
                    class="image-3"
                    id="buttonImagePopup"
                    style={`background-image:url("${buttonImageInfo.buttonImageContent}")`}
                />
            </div>
            <div class="modify margin-top-80"></div>
            <div class="popup-button">
                <a
                    href="#"
                    class="close-button w-button"
                    on:click|preventDefault={() => (isButtonImagePopup = false)}
                    >{"닫기"}</a
                >
                <a
                    href="#"
                    class="quit-button w-button"
                    on:click|preventDefault={() => clickButtonImageAssign()}
                    >{"적용"}</a
                >
            </div>
        </div>
    </div>
</div>
<div
    class="image-upload-popup"
    class:show={isButtonIconPopup}
    on:click={() => (isButtonIconPopup = false)}
>
    <div class="popup-layer image-upload-pop" on:click|stopPropagation>
        <div class="h1-light margin20">
            {"버튼에 적용할 이미지 선택"}
        </div>
        <div class="bring-image-copy">
            <div class="image-upload">
                <img
                    src="/static/images/upload-icon-big.svg"
                    loading="lazy"
                    alt=""
                    class="image-151"
                />
                <div>
                    <a
                        href="#"
                        class="image-upload-button w-button"
                        on:click|preventDefault={clickCustomButtonImage}
                        >{"이미지 파일 가져오기"}</a
                    >
                </div>
            </div>
        </div>
        <div class="h1-light margin20">
            {"기본 아이콘 형태의 이미지 선택"}
        </div>
        <div class="div-block-89" on:click={clickIconImageSelected}>
            <img
                data-type="insta"
                src="/static/images/insta-icon.png"
                loading="lazy"
                width="54"
                alt=""
                class="icon-image"
                class:checked-icon={iconImageList.insta}
            />
            <img
                data-type="facebook"
                src="/static/images/facebook-icon.png"
                loading="lazy"
                alt=""
                class="icon-image"
                class:checked-icon={iconImageList.facebook}
            />
            <img
                data-type="kakaotalk"
                src="/static/images/kakaotalk-icon.png"
                loading="lazy"
                alt=""
                class="icon-image"
                class:checked-icon={iconImageList.kakaotalk}
            />
            <img
                data-type="blog"
                src="/static/images/blog-icon.png"
                loading="lazy"
                alt=""
                class="icon-image"
                class:checked-icon={iconImageList.blog}
            />
            <img
                data-type="youtube"
                src="/static/images/youtube-icon.png"
                loading="lazy"
                alt=""
                class="icon-image"
                class:checked-icon={iconImageList.youtube}
            />
            <img
                data-type="twitter"
                src="/static/images/twitter-icon.png"
                loading="lazy"
                alt=""
                class="icon-image"
                class:checked-icon={iconImageList.twitter}
            />
            <img
                data-type="mail"
                src="/static/images/mail-icon.png"
                loading="lazy"
                class="icon-image"
                class:checked-icon={iconImageList.mail}
            />
            <img
                data-type="shop"
                src="/static/images/shop-icon.png"
                loading="lazy"
                alt=""
                class="icon-image"
                class:checked-icon={iconImageList.shop}
            />
        </div>
        <div
            class="x-button pointer"
            on:click={() => (isButtonIconPopup = false)}
        ></div>
        <div class="select-wrapper">
            <a
                href="#"
                class="image-select-button w-button"
                on:click|preventDefault={clickIconImageSubmit}
                >{"선택하기"}</a
            >
        </div>
    </div>
</div>

<style>
    .link-block {
        border: 2px solid transparent;
    }

    .icon-image.checked-icon {
        border: 2px solid #6372ff;
        border-radius: 5px;
    }

    .elements-con {
        position: relative;
    }
    .lock-image {
        position: absolute;
        right: 5px;
        top: 4px;
    }

    .name-text-form {
        width: 100%;
    }

    .layout-type-wrapper {
        display: flex;
        gap: 8px;
        margin-top: 8px;
        flex-wrap: wrap;
    }

    .layout-type-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
        padding: 10px 8px 8px;
        border: 2px solid #e0e0e0;
        border-radius: 10px;
        min-width: 58px;
        color: #aaa;
        transition:
            border-color 0.15s,
            color 0.15s,
            background 0.15s;
    }

    .layout-type-item:hover {
        border-color: #b0b8ff;
        color: #6372ff;
    }

    .layout-type-item.selected {
        border-color: #6372ff;
        background: #f0f1ff;
        color: #6372ff;
    }

    .layout-icon {
        width: 40px;
        height: 30px;
    }

    .layout-type-label {
        font-size: 11px;
        font-weight: 500;
        white-space: nowrap;
    }

    .inline-icon-area {
        margin-top: 12px;
    }

    .inline-icon-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 10px;
    }

    .inline-icon {
        width: 44px;
        height: 44px;
        cursor: pointer;
        border-radius: 6px;
        border: 2px solid transparent;
        box-sizing: border-box;
        transition: border-color 0.15s;
    }

    .inline-icon.selected {
        border-color: #6372ff;
    }

    .inline-icon.uploaded {
        object-fit: cover;
        background: #f5f5f5;
    }

    .image-upload-area {
        margin-top: 10px;
        /* 업로드/라이브러리 버튼을 세로 스택이 아니라 한 줄에 나란히(좁으면 줄바꿈) */
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        align-items: center;
    }

    .button-image-layer {
        top: auto;
        height: 610px;
    }

    .file-upload-btn {
        cursor: pointer;
    }

    .image-upload-btn {
        width: 136px;
        padding: 0px;
        height: 36px;
    }
    .image-upload-btn-before {
        /* 고정폭(112px) 대신 라벨 길이에 맞춰 자동 폭 → "라이브러리에서 선택" 안 잘림.
           전역 .file-upload-btn은 아이콘 왼쪽 + 텍스트 우측정렬(flex-end)이라
           좁은 버튼에선 어색 → 아이콘 옆에 텍스트를 왼쪽정렬로 붙인다. */
        width: auto;
        min-width: 0;
        justify-content: flex-start;
        padding-left: 42px;
        padding-right: 14px;
        background-position: 12px center;
        white-space: nowrap;
    }

    .file-upload-btn:hover {
        border: none !important;
    }

    .file-upload-text {
        line-height: 36px;
        padding-left: 8px;
        padding-right: 8px;
        height: -webkit-fill-available;
        border-right: 1px dashed #667ead;
    }

    .rotate {
        transform: rotate(180deg);
    }

    .button-action-wrapper img {
        cursor: pointer;
    }

    .dropdown-toggle-scenario {
        display: flex;
        height: 38px;
        width: 100%;
        align-items: center;
    }

    .dropdown-toggle-scenario.block-design {
        width: 100%;
    }

    .youtube-input-form.block-design {
        width: 100%;
    }

    .image-145 {
        cursor: pointer;
    }
    .select-wrapper {
        position: relative;
    }
    .dropdown-list-3 {
        position: relative;
    }

    .scenario-con {
        cursor: pointer;
    }

    .scenario-con:hover {
        border-radius: 5px;
        outline-color: rgb(29 26 199 / 66%);
        outline-offset: 0px;
        outline-style: solid;
        outline-width: 2px;
    }
    .selected-image.block-design {
        display: none;
    }
    .image-upload-popup {
        position: fixed;
    }
    .select-wrapper {
        margin-top: 18px;
    }

    .image-select-button {
        background-color: #6372ff;
        border-radius: 10px;
    }
    .active {
        border: 2px solid #4c4fa7a6;
    }

    .link-form {
        border-radius: 3px;
        padding: 5px 14px;
    }

    /* ── shadcn 토큰 리스킨 (append — 뒤 규칙이 이김). 블록 편집기 DOM/로직 보존, 색·표면만 --sb-* ── */
    .link-block {
        /* 전역 webflow .link-block{width:520px} 덮어써서 래퍼 폭을 꽉 채움.
           왼쪽 패딩을 넓혀(40px) 드래그 핸들이 들어갈 자리를 카드 패딩 안에 확보.
           box-sizing:border-box라야 width:100%가 패딩 포함 → ul 밖으로 안 넘침. */
        box-sizing: border-box;
        width: 100%;
        padding-left: 40px;
        background: hsl(var(--sb-card));
        border: 1px solid hsl(var(--sb-border));
        border-radius: 12px;
    }
    .link-block.active,
    .active {
        border: 2px solid hsl(var(--sb-primary));
    }
    .text-block-93 {
        color: hsl(var(--sb-foreground));
        font-weight: 600;
    }
    .text-block-94 {
        color: hsl(var(--sb-muted-foreground));
    }
    /* 블록 카드가 콘텐츠 컬럼(래퍼) 폭을 꽉 채우게(전역 520px 무시).
       전역 .content-con-wrapper는 margin-left:-20px + display:flex라 ul 밖으로 삐져나감 → 덮어씀. */
    .content-con-wrapper {
        position: relative;
        display: block;
        margin-left: 0;
        width: 100%;
    }
    .content-con-wrapper > div {
        box-sizing: border-box;
        width: 100%;
    }
    /* 드래그 핸들은 카드 왼쪽 패딩(40px) 영역 안에 절대배치 → 폭/정렬에 영향 없이 패딩 안에 위치 */
    .image-145 {
        position: absolute;
        left: 13px;
        top: 18px;
        z-index: 1;
        margin: 0;
        padding: 0;
    }

    /* 입력창만 단일 테두리(필드) + shadcn 인풋 높이/여백(블록엔 textarea 없음). */
    .name-text-form {
        height: 40px;
        padding: 8px 12px;
        font-size: 14px;
        line-height: 1.4;
        background-color: hsl(var(--sb-background));
        color: hsl(var(--sb-foreground));
        border: 1px solid hsl(var(--sb-input));
        border-radius: 6px;
    }
    .link-form,
    .youtube-input-form {
        background: transparent;
        border: none;
        padding: 0;
    }
    .icon-image.checked-icon,
    .inline-icon.selected {
        border-color: hsl(var(--sb-primary));
    }
    .layout-type-item {
        border: 2px solid hsl(var(--sb-border));
        color: hsl(var(--sb-muted-foreground));
    }
    .layout-type-item:hover {
        border-color: hsl(var(--sb-primary));
        color: hsl(var(--sb-primary));
    }
    .layout-type-item.selected {
        border-color: hsl(var(--sb-primary));
        background: hsl(var(--sb-primary) / 0.08);
        color: hsl(var(--sb-primary));
    }
    .image-select-button {
        background-color: hsl(var(--sb-primary));
        color: hsl(var(--sb-primary-foreground));
    }
    /* 간격 조절: 미니 미리보기 카드(좁게/보통/넓게 · 없음/실선/점선) */
    .gap-block {
        display: block;
    }
    .divide-second-label {
        margin-top: 16px;
    }
    /* shadcn ToggleGroup(outline) 세그먼트 스타일: 한 줄에 붙은 아웃라인 토글, 선택만 강조 */
    .divide-grid {
        display: flex;
        gap: 4px;
        margin-top: 6px;
    }
    .divide-card {
        flex: 1 1 0;
        min-width: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
        padding: 10px 6px;
        border: 1px solid hsl(var(--sb-input));
        border-radius: 8px;
        background: hsl(var(--sb-background));
        color: hsl(var(--sb-foreground));
        cursor: pointer;
        transition:
            border-color 0.15s,
            background 0.15s,
            color 0.15s;
    }
    .divide-card:hover {
        background: hsl(var(--sb-muted) / 0.6);
    }
    /* 선택 상태(toggle on): 옅은 primary 틴트 + primary 테두리/글자 */
    .divide-card.active {
        border-color: hsl(var(--sb-primary));
        background: hsl(var(--sb-primary) / 0.1);
        color: hsl(var(--sb-primary));
    }
    .divide-card-label {
        font-size: 12px;
        font-weight: 500;
        color: inherit;
    }
    .divide-card.active .divide-card-label {
        font-weight: 600;
    }
    /* 간격 미리보기: 위/아래 바 + 가변 여백 */
    .divide-gap-preview {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;
        width: 100%;
        height: 46px;
    }
    /* 미리보기는 카드 색(currentColor)을 따라감 → 선택 시 primary로 함께 틴트 */
    .dv-bar {
        height: 7px;
        border-radius: 2px;
        background: currentColor;
        opacity: 0.4;
    }
    .dv-gap {
        display: block;
    }
    /* 구분선 미리보기: 선 샘플 */
    .divide-line-preview {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 46px;
    }
    .dv-line {
        width: 78%;
        border-top: 2px currentColor;
        opacity: 0.65;
    }
    .dv-line.solid {
        border-top-style: solid;
    }
    .dv-line.dashed {
        border-top-style: dashed;
    }
    .dv-line-none {
        font-size: 11px;
        opacity: 0.55;
    }
    /* 타깃 선택 드롭다운도 셀렉트박스/팝오버 룩으로 통일 */
    .dropdown-toggle-scenario {
        height: 40px;
        padding: 0 12px;
        align-items: center;
        border: 1px solid hsl(var(--sb-input));
        border-radius: 6px;
        background: hsl(var(--sb-background));
    }
    .dropdown-list-3 {
        background: hsl(var(--sb-card));
        border: 1px solid hsl(var(--sb-border));
        border-radius: 10px;
    }
    .text-block-26,
    .text-block-101 {
        color: hsl(var(--sb-foreground));
    }
    .text-block-25 {
        color: hsl(var(--sb-muted-foreground));
    }
</style>
